import React, { useEffect } from "react";
import "../css/services.css";
import { Link } from "react-router";

export const HeroImgServices = () => {
  useEffect(() => {
    window.scroll(0, 0);
  });
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/servicesBanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/servicesBannerMob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const ServicesContent = () => {
  const servicesData = [
    {
      title: "Lease Due",
      subtitle: "Diligence",
      points: [
        "Comprehensive lease review and abstraction",
        "Lease data verification and rent roll validation",
        "REIT income abstraction",
        "Flexible reporting options, including summary of Reimbursements, Renewal Options, Termination Rights, SNDA provisions and more",
        "Telecom, License Agreement, and Service Contract abstraction",
      ],
      imgSrc: "/assets/services/cardimg1.png",
    },
    {
      title: "Financial Due",
      subtitle: "Diligence",
      points: [
        "ARGUS™ cash flow modeling and review",
        "Net Operating Income (NOI) analysis, including historical operating statement review and variance analysis",
        "Review of closing and post-close prorations",
        "Residential/Storage tenant lease file review",
      ],
      imgSrc: "/assets/services/cardimg2.png",
    },
    {
      title: "CAM / Operating Expenses",
      subtitle: "Reconciliations",
      points: [
        "Verification of OPEX methodology computations",
        "Property expense calculations and validation",
        "CAM dispute challenges and resolutions for both landlord and tenant",
        "Preparation of CAM / Operating Expense reconciliations",
      ],
      imgSrc: "/assets/services/cardimg3.png",
    },
    {
      title: "ONGOING PORTFOLIO LEASE MAINTENANCE ",
      subtitle: "(BOTH LANDLORD & TENANT)",
      points: [
        "Outsourced lease abstraction, report generation, and database maintenance",
        "Reduce overhead costs by eliminating the need for a full in-house team",
        "Periodic (monthly / quarterly) lease document updates",
        "Extensive experience with numerous database and ERP systems, including CoStar, JDE, MRI, and PeopleSoft",
        "Yardi accounting system implementation and abstraction for property owners / landlords",
      ],
      imgSrc: "/assets/services/cardimg4.png",
    },
    {
      title: "Estoppel Certificate",
      subtitle: "Analysis",
      points: [
        "Preparation of and/or edits to draft estoppel certificates",
        "Review of executed estoppels in excel noting any variances between estoppel vs. lease vs. rent roll",
        "Coordination of estoppel coverage with acquisition and loan closing requirements",
        "Work in tandem with deal team, legal counsel, and lender team",
      ],
      imgSrc: "/assets/services/cardimg5.png",
    },
  ];

  return (
    <div className="container">
      <div className="heading-page">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">SERVICES</span>
          <br />
        </h1>
        <span className="heading-nextline">WE OFFER</span>
      </div>
      <div className="services-card-container">
        {servicesData.map((service, index) => (
          <div
            className={`services-card ${
              index % 2 === 0 ? "reverse-service-card" : ""
            }`}
            key={index}
          >
            <div className="services-card-left">
              <h2 className="services-card-title">
                {service.title} <br />
                <strong>{service.subtitle}</strong>
              </h2>
              <div className="service-card-text">
                <ul>
                  {service.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div
              className={`services-card-right ${
                index % 2 === 0 ? "reverse-service-img" : ""
              }`}
            >
              <img src={service.imgSrc} alt="" />
            </div>
          </div>
        ))}
      </div>
      <Link to="/contact">
        <button className="submit-btn center-align">Let's Connect →</button>
      </Link>
    </div>
  );
};
